import { FormEvent } from 'react';
import { IListItem } from '@nkr/models/index';
import { AboType, AdpVoucherHolderStatus } from '@nkr/enums/index';
import { Col, ControlLabel, Form, FormControl, FormGroup, Panel } from 'react-bootstrap';

interface IProps {
    abo: AboType,
    ckdStatus: number,
    status: AdpVoucherHolderStatus,
    aboTypeList: IListItem[],
    ckdStatusList: IListItem[],
    voucherHolderStatusList: IListItem[],
    onFieldChange: (e: FormEvent<FormControl & HTMLSelectElement>) => void
}

const AdminSection = (props: IProps) => {
    return (
        <Panel bsStyle='info'>
            <Panel.Heading>ADMIN-ONLY: This data should get auto-populated, but can be manually set as necessary</Panel.Heading>
            <Panel.Body>
                <Form horizontal>
                    <FormGroup>
                        <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>ABO:</Col>
                        <Col xs={12} lg={6}>
                            <FormControl
                                componentClass='select'
                                id='abo'
                                value={props.abo}
                                onChange={props.onFieldChange}
                            >
                                <option value={0}>- Please Select -</option>
                                {props.aboTypeList.map(item =>
                                    <option key={'abo-' + item.id} value={item.id}>{item.description}</option>
                                )}
                            </FormControl>
                        </Col>
                    </FormGroup>

                    <FormGroup>
                        <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>CKD Status:</Col>
                        <Col xs={12} lg={6}>
                            <FormControl
                                componentClass='select'
                                id='ckdStatus'
                                value={props.ckdStatus}
                                onChange={props.onFieldChange}
                            >
                                <option value={0}>Unknown</option>
                                {props.ckdStatusList.map(item =>
                                    <option key={'ckd-status-' + item.id} value={item.id}>{item.description}</option>
                                )}
                            </FormControl>
                        </Col>
                    </FormGroup>

                    <FormGroup style={{ marginBottom: 0 }}>
                        <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Voucher Status:</Col>
                        <Col xs={12} lg={6}>
                            <FormControl
                                componentClass='select'
                                id='status'
                                value={props.status}
                                onChange={props.onFieldChange}
                            >
                                {/* <option value={0}>- Please Select -</option> */}
                                {props.voucherHolderStatusList.map(item =>
                                    <option key={'vh-status-' + item.id} value={item.id}>{item.description}</option>
                                )}
                            </FormControl>
                            <span className='label label-warning'>WARNING: do not use Status to redeem, use Actions &gt; Start Redemption</span>
                        </Col>
                    </FormGroup>
                </Form>
            </Panel.Body>
        </Panel>
    );
}

export default AdminSection;